import React from "react";
import {Redirect, Route} from "react-router-dom";
import {isLoggedIn} from "../services/AccountService";

export default ({ component: C, props: cProps, ...rest }) =>
    <Route
        {...rest}
        render={props =>
            isLoggedIn()
                ? <C {...props} {...cProps} />
                : <Redirect
                    to={`/login?redirect=${props.location.pathname}${props.location
                        .search}`}
                />}
    />;
